import axios from '@/plugins/axios.js';
import wait from '@/plugins/vue-wait.js';

export default {
    /**
     * Load automations
     */
    async fetchAutomations({ commit, rootState }) {
        wait.start('fetching.automations');

        try {
            const response = await axios.get('automations', {
                params: {
                    account_id: rootState.authUser.account.id,
                },
            });

            commit('setAutomations', response.data.data);

            wait.end('fetching.automations');
        } catch (error) {
            wait.end('fetching.automations');

            throw error;
        }
    },
};
